export enum SubnavState {
  hidden = 'hidden',
  collapsed = 'collapsed',
  full = 'full',
  none = 'none'
}
